export function listGroupIngredients (group) {
  return group.ingredients || []
}
